import React, { useState, useEffect } from 'react';

// import pageImage from '../../assets/images/page.png';
import drop from '../../assets/images/drop.png';
// import btnImage from '../../assets/images/btn.png';
import { Link } from 'react-router-dom';
import StatusTag from '../StatusTag';

const Header = ({ lead, otherGroups }) => {
	const [groupListDropDown, setGroupListDropDown] = useState(false);

  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (isOpen && !event.target.closest('.extraPagesWrapers')) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isOpen]);

  const toggleState = () => {
    setIsOpen(!isOpen);
  };

	return (
		<div className='mainContentMemberWraper'>
			<div className='memberInfoSection'>
				<span className='memberImage'>
					<img
						alt='memberimage'
						src={lead.fbuser?.profileImage}
						className='memberImg'
					/>
				</span>
				<span className='memberInfo mainWrapers'>
					{/*Use pending className or approved className to change the status color */}
					<span className='nameMember memberInfoWrapers'>
						{lead.fbuser?.firstName + ' ' + lead.fbuser?.lastName}
						{/*<span
							className={
								'memberStatus ' +
								(lead.status === 'Approved'
									? 'approved'
									: lead.status === 'Declined'
									? 'cancel'
									: lead.status === 'Removed'
									? 'pending'
									: '')
							}
						>
							{lead.status}
						</span>*/}
						<StatusTag status={lead.status} />
					</span>
					<span className='pageAssignedInfo'>
						<span className='assignedPageLogo'>
							{/* <img alt='memberimage' src={pageImage} className='pageImg' /> */}
						</span>
						<span className='pageInformations fullWidthWraper'>
							<span className='assignedHeading'>REQUEST SENT TO</span>
							
							{otherGroups && otherGroups.length > 0 ? (
                <span className="pagesDropdownWrapers">
                {/* <span className='assignedPageName hasDropdown'>{lead.group?.groupName}({lead._id})</span> */}
                 <span onClick={toggleState} className='assignedPageName hasDropdown'>{lead.group?.groupName}</span>
                 {isOpen && (
                  <ul className="extraPagesWrapers">
                    {otherGroups.map((group, g) => {
                        return (
                          <li><Link to={'/member-details/' + group._id} onClick={toggleState}>
                            <span key={g}>{group.group?.groupName}</span>
                          </Link></li>
                        );
                      })}
                  </ul>
                  )}

								{/* <span
									className='selectPageDropdown'
									onClick={() => setGroupListDropDown((val) => !val)}
								>
									<img alt='memberimage' src={drop} className='dropdownIcon' />
									<ul
										className={
											'pageListsDropdown ' + (groupListDropDown && 'opened')
										}
									>
										{otherGroups.map((group, g) => {
											return (
												<Link to={'/member-details/' + group._id}>
													<li key={g}>{group.group?.groupName}</li>
												</Link>
											);
										})}
									</ul>
								</span> */}
                
                </span>
							):(
            <span className='assignedPageName'>{lead.group?.groupName}</span>
              )}
						</span>
					</span>
				</span>
			</div>
			{/* <div className='rightBtn'>
				<span className='detailPageBtn'>
					<img alt='memberimage' src={btnImage} className='rightBtnDetails' />
				</span>
			</div> */}
		</div>
	);
};

export default Header;
